import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@mui/material";
import MxModalTemplate2 from "@rf-l1/modal/MxModalTemplate2";
import MxTypography from "@rf-l1/MxTypography";
import MxFormL3TextAreaField from "@rf-l3/form/MxFormL3TextAreaField";
import useModal from "@rf/base/modal/useModal";
import Yup from "@rf/yup/yup-extensions";
import { FormProvider, useForm } from "react-hook-form";
import MxButtonIa from "@rf-l1/buttons/MxButtonIa";

const useSeoGenerateTitleDescription = () => {
  const { modal } = useModal();

  const handleOpenModalGeneratorDescriptionAndTitle = async (
    instructions: string
  ) => {
    return modal({
      template: <Template />,
      data: {
        instructions: instructions
      },
      options: {
        title: "Información adicional",
        size: {
          xs: {
            width: "100%",
            maxWidth: "430px"
          },
          sm: {
            width: "100%",
            maxWidth: "500px",
            minWidth: "400px"
          },
          md: {
            width: "100%",
            maxWidth: "500px",
            minWidth: "400px"
          },
          lg: {
            width: "100%",
            maxWidth: "500px",
            minWidth: "400px"
          },
          xl: {
            width: "100%",
            maxWidth: "500px",
            minWidth: "400px"
          }
        }
      }
    });
  };

  return { handleOpenModalGeneratorDescriptionAndTitle };
};

export default useSeoGenerateTitleDescription;
const schema = Yup.object().shape({
  description: Yup.string()
});

const Template = () => {
  const { onConfirm, getData } = useModal();
  const { instructions = "" } = getData() as { instructions: string };
  const FORM_CONFIG = useForm({
    mode: "onChange",
    defaultValues: {
      description: instructions
    },
    resolver: yupResolver(schema)
  });
  const onSubmit = data => {
    return new Promise<void>(resolve => {
      onConfirm(data);
      resolve();
    });
  };

  return (
    <MxModalTemplate2>
      <FormProvider {...FORM_CONFIG}>
        <form
          onSubmit={FORM_CONFIG.handleSubmit(onSubmit)}
          style={{ width: "100%" }}
        >
          <Grid container gap={2}>
            <Grid item xs={12} container gap={1}>
              <MxTypography color="grey.600" fontWeight={400} variant="overline">
                Añade información que solo tu conoces: cuanto más compartas, mejor
                será la descripción generada por la IA.
              </MxTypography>
            </Grid>
            <Grid item xs={12}>
              <MxFormL3TextAreaField
                withreacthookform={1}
                minRows={3}
                name="description"
                placeholder="A solo 10 minutos de la playa"
                style={{ height: "125px" }}
              />
            </Grid>
            <Grid item xs={12} container justifyContent="center">
              <MxButtonIa type="submit">Generar descripción</MxButtonIa>
            </Grid>
          </Grid>
        </form>
      </FormProvider>
    </MxModalTemplate2>
  );
};
